import React, { useState } from 'react';
import { DateRange } from 'react-date-range';
import moment from 'moment';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import classNames from 'classnames';
import classes from './index.module.scss';
import LandaModal from '../../../../../../../../../components/containers/Modal/Modal';
import Button from '../../../../../../../../../components/generics/buttons/Button';
import useSignLease from '../../../../../../context';
import enUS from 'date-fns/locale/en-US';
import { useMediaQuery } from 'react-responsive';
import PropertyHeader from '../PropertyHeader';
import Typography from '../../../../../../../../../components/generics/texts/Typography';

interface DateSelectionProps {
  onClose: () => void;
}

const DateSelection = ({ onClose }: DateSelectionProps) => {
  const { data, startDate, setStartDate, endDate, setEndDate } = useSignLease();
  const isMobile = useMediaQuery({ query: '(max-width: 480px)' });
  const [selectionRange, setSelectionRange] = useState({
    startDate: startDate ? moment(startDate).toDate() : new Date(),
    endDate: endDate
      ? moment(endDate).toDate()
      : moment().add(1, 'days').toDate(),
    key: 'selection',
  });

  const handleSelect = (ranges: any) => {
    const isRenewal = data?.units[0].onMarketLease?.isRenewal;

    if (isRenewal) {
      setSelectionRange({
        ...selectionRange,
        startDate: moment(data?.units[0].onMarketLease.startDate).toDate(),
        endDate: ranges.selection.endDate,
        key: ranges.selection.key,
      });
      setStartDate(data?.units[0].onMarketLease.startDate || null);
    } else {
      setSelectionRange(ranges.selection);
    }
  };

  const handleSetDates = () => {
    if (
      moment(selectionRange.startDate).isSame(selectionRange.endDate, 'day')
    ) {
      setEndDate(
        moment(selectionRange.endDate).add(1, 'days').format('YYYY-MM-DD')
      );
    } else {
      setEndDate(moment(selectionRange.endDate).format('YYYY-MM-DD'));
    }
    setStartDate(moment(selectionRange.startDate).format('YYYY-MM-DD'));
    onClose();
  };

  const handleReset = () => {
    setStartDate(data?.units[0].onMarketLease.startDate || null);
    setEndDate(data?.units[0].onMarketLease.endDate || null);
    onClose();
  };

  return (
    <LandaModal
      isOpen={true}
      onClose={onClose}
    >
      <div className={classNames(classes.container)}>
        <div className={classes.header}>
          <h2>Select Dates</h2>
        </div>
        <PropertyHeader />
        <div className={classes.subheader}>
          <div className={classes.summary}>
            <p>
              <strong>
                {moment(selectionRange.endDate).diff(
                  moment(selectionRange.startDate),
                  'days'
                ) +
                  1 +
                  ' days'}
              </strong>
              {moment(selectionRange.startDate).format('MMM D, YYYY')} -{' '}
              {moment(selectionRange.endDate).format('MMM D, YYYY')}
            </p>
          </div>
        </div>
        <div className={classes.inputs}>
          <div className={classes.inputBox}>
            <Typography className={classes.inputBoxTitle}>Move-in</Typography>
          </div>
          <div className={classes.inputBox}>
            <Typography className={classes.inputBoxTitle}>Move-out</Typography>
          </div>
        </div>
        <div className={classes.dateInputContainer}>
          <DateRange
            ranges={[selectionRange]}
            onChange={handleSelect}
            minDate={moment(data?.units[0].onMarketLease.startDate).toDate()}
            maxDate={moment(data?.units[0].onMarketLease.endDate).toDate()}
            rangeColors={['#144f4d']}
            locale={enUS}
            moveRangeOnFirstSelection={false}
            months={isMobile ? 1 : 2}
            direction="horizontal"
          />
        </div>
        <div className={classes.actions}>
          <Button onClick={handleSetDates}>Set Dates</Button>
          <Button
            onClick={handleReset}
            variant="secondary"
          >
            12-Month Lease
          </Button>
        </div>
      </div>
    </LandaModal>
  );
};

export default DateSelection;
